import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePostRequest } from "../../services/PostTemplate";
import * as Yup from "yup";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import ZDropdown from "../../components/zDropdown/ZDropdown";

const UpdateUserForm = ({ onCloseModal, getAllUsers, companyId }) => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("");

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("This field is required."),
    email: Yup.string().required("This field is required.").email(),
    password: Yup.string().required("This field is required."),
    userTypeId: Yup.string().required("This field is required."),
    gateId: Yup.string().when("userTypeId", {
      is: (val) => val === "5",
      then: Yup.string().required("This field is required."),
    }),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      name: "",
      email: "",
      password: "",
      gateId: "",
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        data["userTypeId"] = parseInt(data["userTypeId"]);
        data["gateId"] = parseInt(data["gateId"]);
        data["companyId"] = parseInt(companyId);
        await handlePostRequest(data, "user/addNew");
        setloading(false);
        setloadingIcon("pi pi-save");
        getAllUsers();
        onCloseModal();
      } catch (error) {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  return (
    <div className="card Card__Round">
      <div className="Form__Header">
        <h1> Add User </h1>
      </div>
      <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                required
                placeholder="Enter Name"
                label="Name"
                keyName="name"
                {...props}
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                required
                placeholder="Enter email"
                label="Email"
                keyName="email"
                {...props}
              />
            </div>
          </div>

          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZDropdown
                {...props}
                label="Role"
                required
                valueOption="id"
                keyName="userTypeId"
                placeholder="Select Role"
                optionLabel="description"
                url="lov/userTypes"
              />
            </div>
          </div>
          {formik.values.userTypeId === 5 && (
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field">
                <ZDropdown
                  {...props}
                  label="Gate"
                  required
                  valueOption="id"
                  keyName="gateId"
                  placeholder="Select Gate"
                  optionLabel="description"
                  url={`lov/gates/${companyId}`}
                />
              </div>
            </div>
          )}
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                required
                type={"password"}
                placeholder="Enter password"
                label="Password"
                keyName="password"
                {...props}
              />
            </div>
          </div>
        </div>

        <div className="Down__Btn">
          <Button
            disabled={loading}
            icon={loadingIcon || ""}
            iconPos="right"
            label={"Add User"}
            className="Btn__Dark"
          />
        </div>
      </form>
    </div>
  );
};

export default UpdateUserForm;
